import { Application, Controller } from 'stimulus'
import './component.scss'
import $ from 'jquery'

const COMMON_PARENT_TAG = 'article'
const ERROR_FIELD_CLASS = '.cv-form-wall-and-roof__error'
const PREFECTURE_CLASS = '.select-prefectures-name'
const CITIES_CLASS = '.select-city-name'
const DEFAULT_PREFECTURE_NAME = '都道府県'
const DEFAULT_CITY_NAME = '指定なし'

const app = Application.start()

app.register('cv-form-wall-and-roof', class extends Controller {
  connect () {
    const $this = $(this.element)
    const $cities = $this.find(CITIES_CLASS)

    $this.find('form').on('submit', function (e) {
      const $submitTrigger = $(e.currentTarget).find('[type="submit"]')

      // submitの連打防止のため非活性化する
      $submitTrigger.attr('disabled', true)

      const $errors = $(ERROR_FIELD_CLASS).filter(function (_index, element) {
        return $(element).css('display') === 'block'
      })
      if ($errors.length > 0) {
        e.preventDefault()

        // エラーの場合は即座に活性化させる
        $submitTrigger.attr('disabled', false)
      }

      // 特定の操作をすると、$errorsが出現する前に処理が通ってしまうので復元のため少し時間を置いて活性化させる。2秒設定はテキトーです。
      // NOTE:特定の操作とは ⇒ 全て正常入力後、電話番号を1桁増やしてノータイムでsubmitする など
      setTimeout(() => {
        $submitTrigger.attr('disabled', false)
      }, 2000)
    })

    $this.find('input[id="tel"]').on('keyup', function (e) {
      const $tel = $(e.currentTarget)
      const $errorField = $tel.closest(COMMON_PARENT_TAG).find(ERROR_FIELD_CLASS)

      $.getJSON('/api/validation/telephone_book',
        {
          tel: $tel.val()
        }
      ).done(() => {
        $errorField.css('display', 'none')
      }).fail(() => {
        $errorField.css('display', 'block')
      })
    })

    $this.find(PREFECTURE_CLASS).on('change', function (e) {
      const $prefectures = $(e.currentTarget)
      const selectedPrefecture = $prefectures.children('option:selected').text()
      fetchCitiesFromPrefecture(selectedPrefecture)
    })

    const fetchCitiesFromPrefecture = function (selectedPrefecture) {
      if (selectedPrefecture === DEFAULT_PREFECTURE_NAME) {
        removeSelectedCities()
        return
      }

      $.ajax({
        url: '/api/prefecture/' + selectedPrefecture + '/cities',
        method: 'GET',
        data: 'json',
        error: function (xhr, status, error) {
          console.error('AJAX Error: ' + status + ' / ' + error)
        },
        success: function (response) {
          buildCitiesSelectBox(response)
        }
      })
    }

    const buildCitiesSelectBox = function (response) {
      removeSelectedCities()
      $.each(response, function () {
        $cities.append(
          $('<option>').html(this.name).val(this.id)
        )
      })
    }

    const removeSelectedCities = function () {
      $this.find(CITIES_CLASS + ' > option').remove()
      $cities.append(
        $('<option>').html(DEFAULT_CITY_NAME).val(null)
      )
    }
  }

  addCityName (e) {
    const element = e.target
    const selectedIndex = element.selectedIndex
    const cityName = element.options[selectedIndex].textContent

    document.getElementById('select-city-name').value = cityName
  }
})
